import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  private authChangeSubject = new Subject<void>();
  
  // Observable that components can subscribe to
  public authChange$ = this.authChangeSubject.asObservable();
  
  // Method to notify subscribers that auth state has changed
  notifyAuthChange() {
    this.authChangeSubject.next();
  }
}
